export const initialState = {
  sending: false,
  succeed: null,
  rejected: null,
  error: null,
};
const createReqReducer = (consts, wrapData = false) => (
  state = initialState,
  action,
) => {
  const {
    SEND,
    SUCCEED,
    REJECTED,
    ERROR_ENCOUNTERED,
    ADD_META,
    CLEAR,
  } = consts;
  const { payload, type } = action;

  switch (type) {
    case SEND:
      return {
        ...state,
        ...initialState,
        sending: true,
      };
    case SUCCEED: {
      const objectResponse = wrapData ? { data: payload } : payload;

      return Object.assign(
        {},
        initialState,
        {
          succeed: true,
        },
        Array.isArray(payload) ? { list: payload } : objectResponse,
      );
    }
    case REJECTED:
      return {
        ...initialState,
        ...payload,
        rejected: true,
      };
    case ERROR_ENCOUNTERED:
      return {
        ...initialState,
        error: payload,
      };
    case ADD_META:
      return {
        ...state,
        meta: payload,
      };
    case CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default createReqReducer;



// WEBPACK FOOTER //
// ./src/utils/redux/req-reducer.js